import { REMOVE_DOCUMENT_TITLE } from './constants';

export function restoreTitle() {
  return (dispatch, getState) => {
    const {
      auth: { documentTitleDuringTokenExpiration },
    } = getState();
    if (documentTitleDuringTokenExpiration) {
      document.title = documentTitleDuringTokenExpiration;
      dispatch({
        type: REMOVE_DOCUMENT_TITLE,
      });
    }
  };
}
